module.exports = __webpack_public_path__ + "media/src/images/mails/green_tick@2x-16684b55746eff11d11793c151f2c033.png";